export default class ShortUrl {
	constructor(http, agp) {
		this.http = http;
		this.agp = agp;
	}
	/**
	 * @param {{ board?: true, offer?: string | number, apply?: boolean, path?: string | true  }} [param]
	 * @returns string | Promise<string>
	 */
	url(param) {
		const siteconf = this.agp.$siteconf;
		const root = (location.protocol || 'https:') + '//' + siteconf.root + '/s/';
		if(!param) param = {};
		if(!param.path) param.path = location.pathname + location.search;
		if(!param.board && !param.offer) {
			if(['/', '/offers', '/home'].includes(param.path)) {
				param.board = true;
				if(!siteconf.hideHome && param.path == '/offers')
					param.list = true;
			} else if(param.path.startsWith('/offers/0')) {
				param.offer = 'spont';
			} else if(param.path.startsWith('/offers/')) {
				const parts = param.path.split('/').slice(2);
				param.offer = parts[0];
				param.apply = parts[2] == 'post';
			}
		}
		if(param.board)
			return root + (param.list ? 'l.' : 'j.') + siteconf.boardId;
		if(param.offer == 'spont')
			return root + 's.' + siteconf.boardId;
		if(param.offer)
			return root
				+ (param.apply ? 'a.' : 'o.')
				+ parseInt(param.offer).toString(36)
				+ '.' + siteconf.boardId.substring(0, 3);
		if(param.path) {
			const path = param.path[0] == '/' ? param.path.substring(1) : param.path;
			const tail = findTail(path);
			console.log(tail);
			if(!tail) throw new Error('unable to sign shorten request');
			return this.http.get('/c/shorten/' + tail + '/' + path)
				.then(short => root + short);
		}
		throw new Error('unhandled short url params');
	}
}

function hash(s) { return window.sha256_words(s)[0] & 255 }
const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$-_.+!*\'()';
function findTail(str) {
	const target = (hash(str) + 1) & 255;
	for(let a of chars)
		if(hash(str + a) == target)
			return a;
	for(let a of chars)
		for(let b of chars)
			if(hash(str + a + b) == target)
				return a + b;
	for(let a of chars)
		for(let b of chars)
			for(let c of chars)
				if(hash(str + a + b + c) == target)
					return a + b + c;
}
